export const PlayingIcon = ({ className }: { className?: string }) => {
  console.log('---------------', { className })
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="6" width="4" height="12" rx="1" />
      <rect x="14" y="6" width="4" height="12" rx="1" />
    </svg>
  );
};

PlayingIcon.displayName = "PlayingIcon";
